import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '~/hooks/useAuth';
const Header = () => {
    const [authState, dispatch] = useAuth();
    const navigate = useNavigate();
    const logOut = () => {
        sessionStorage.clear();
        dispatch({ type: 'LOGOUT' });
        navigate('/login');
    };
    return (_jsx("header", { className: "flex items-center bg-white px-7 py-5", id: "header", children: _jsx("div", { children: _jsx("button", { className: "font-bold text-gray-500 hover:text-gray-400", id: "log-out", onClick: logOut, children: "Log Out" }) }) }));
};
export default Header;
